import React from 'react';


import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem, Card, CardHeader, ListGroup, ListGroupItem, Row, Col, Table,
} from 'reactstrap';
import { useNavigate, useLocation } from "react-router-dom";

const CertificateInformation6 = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const coursetrack = location.state ? location.state.courseTrack : "";
    const coursename = location.state ? location.state.courseName : "";
    const [open, setOpen] = React.useState(['7']); // Initialize open state with an empty array

    const toggle = (id) => {
        setOpen(prevOpen => {
            if (prevOpen.includes(id)) {
                // If the section is already open, remove it from the open state
                return prevOpen.filter(item => item !== id);
            } else {
                // If the section is not open, add it to the open state
                return [...prevOpen, id];
            }
        });
    };

    const handleEnrollClick = () => {

        navigate("/application-form", {
            state: {
                courseTrack: coursetrack,
                courseName: coursename,

            },
        });
    };

    return (

<>
  



        <div className="container mt-1 p-3 mb-1">


            <Row>
                <Col>
                    <h2 className=" text-center" style={{ color: '#123fae' }}
                    >
                       Certificate Course in IT Network Support

                        {/* <a href='a'
                            style={{ float: "right", fontSize: 15, color: "#e74c3c" }}
                            className="d-block mx-auto"
                            onClick={(event) => {
                                event.preventDefault(); // Prevents the default behavior (page reload)
                                handleEnrollClick(); // Calls your handleEnrollClick function
                            }}
                        >
                            Register Now
                        </a> */}

                    </h2>




                </Col>
            </Row>
            {/* <h4>Course Details:</h4> */}
            <Row>
                <Col md={6} xs={12} className="mt-3 ">
                    <Card >
                        <CardHeader>
                            Course Details:
                        </CardHeader>




                        <ListGroup flush >

                            <ListGroupItem>
                                Language: English
                            </ListGroupItem>
                            <ListGroupItem>
                                Duration: 120 hours (3 months)
                            </ListGroupItem>
                            <ListGroupItem>
                                Learning Mode: Online
                            </ListGroupItem>
                            <ListGroupItem>
                                Certificate of Completion
                            </ListGroupItem>


                        </ListGroup>
                    </Card  ></Col>
                <Col md={6} xs={12} className="mt-3 ">
                    <Card style={{ minHeight: "100%" }}>
                        <CardHeader >
                            Eligibility:
                        </CardHeader>




                        <ListGroup flush className="px-2">

                            <ListGroupItem>
                                <li> Learner should preferably be a 12th std. Pass student .</li>

                            </ListGroupItem>

                        </ListGroup>
                    </Card></Col>
            </Row>
            <br />
            <hr />
            <div >
                <h5 style={{ position: "relative" }}>
                    <span >
                        &#x1F449;
                    </span>
                    Why Certificate Course in IT Network Support
                </h5>
                <p>
                    In simple words, IT Network Support Technician is the one who troubleshoots, monitors, maintains the Internet and Intranet connectivity also the learner can monitor and maintain the uptime of various types of Networking Devices such as Routers, Switches, and Hubs.  </p>

            </div>
            <hr />
            <h5 style={{ position: "relative" }}>

                What does an IT Network Support Technician do?
            </h5>
            <ul>
                <li>Using Basic Troubleshooting skills, learner can identify diagnose and resolve the Basic IT network related problems.</li>
                <li>Learner can do primary level of fault finding and take necessary actions for IT network related issues.</li>
                <li> Learner can also perform tasks like assigning IP addresses, monitoring network uptime, crimping of LAN cables, configuring and maintaining Wi-Fi network.</li>


            </ul>

            <h5 style={{ position: "relative" }}>

                Why take Admission?
            </h5>

            <p>An IT Network support technician can work with companies / enterprises having an IT infrastructure including Routers and Switches and Internet connectivity or the companies who are providing Networking devices sales and support.</p>
            <p>Learner can do a job or can work as an IT Hardware Support Consultant. A fresher can draw up to Rs. 100,000/- p.a</p>
            <hr />

            <h5 style={{ position: "relative" }}>

                Hierarchy
            </h5>

            <p>In any typical industry enterprise having even a basic IT Infrastructure including desktops and laptops, learners would work with a team of such more hardware and network support technicians who would guide them. Learner can further pursue to become a System Engineer or a System administrator as per his/her liking and abilities.</p>
            <hr />
            <h5 style={{ position: "relative" }}>

                Tools
            </h5>

            <p>An IT Hardware Support Technician uses tools like IT Helpdesk, hardware monitors, and multi-meters for providing hardware support. Knowledge of few other tools like memtest86, CPUID (open source system hardware monitoring tool), and few similar open source tools can be beneficial for an IT Hardware Support Technician.</p>
            <hr />


            <div >
                <h5 style={{ left: "0" }}>Certification</h5>
                <ul><li> IT Network Support course is jointly certified by CDOE GJUST and HKCL.</li>
                </ul>
                <hr />
            </div>
            
            <div >
                <h5 style={{ left: "0" }}>Academic Approach</h5>
                <p>
                    The academic approach of the courses focuses on the “work-centric” education i.e. begin with work (and not from a book!), derive knowledge from work and apply that knowledge to make the work more wholesome, useful and delightful. The ultimate objective is to empower the Learner to engage in socially useful and productive work. It aims at leading the learner to his/her rewarding career as an employee or entrepreneur as well as development of the community to which s/he belongs.
                    Learning methodology:
                </p>


                <ul>
                    <li>Step -1: Learners are given an overview of the course and its connection to life and work.</li>
                    <li>Step -2: Learners are exposed to the specific tool(s) used in the course through the various real-life applications of the tool(s).</li>
                    <li>Step -3: Learners are acquainted with the careers and the hierarchy of roles they can perform at workplaces after attaining increasing levels of mastery over the tool(s).</li>
                    <li>Step -4: Learners are acquainted with the architecture of the tool or tool map so as to appreciate various parts of the tool, their functions, utility and inter-relations.</li>
                    <li>Step -5: Learners are exposed to simple application development methodology by using the tool at the beginner’s level.</li>
                    <li>Step -6: Learners perform the differential skills related to the use of the tool to improve the given ready-made industry-standard outputs.</li>
                    <li>Step -7: Learners are engaged in appreciation of real-life case studies developed by the experts.</li>
                    <li>Step -8: Learners are encouraged to proceed from appreciation to imitation of the experts.</li>
                    <li>Step -9: After the imitation experience, they are required to improve the expert’s outputs so that they proceed from mere imitation to emulation.</li>
                    <li>Step -10: Emulation is taken a level further from working with differential skills towards the visualization and creation of a complete output according to the requirements provided. (Long Assignments)</li>
                    <li>Step -11: Understanding the requirements, communicating one’s own thoughts and presenting are important skills required in facing an interview for securing a work order/job. For instilling these skills, learners are presented with various subject-specific technical as well as HR-oriented questions and encouraged to answer them.</li>
                    <li>Step -12: Finally, they develop the integral skills involving optimal methods and best practices to produce useful outputs right from scratch, publish them in their ePortfolio and thereby proceed from emulation to self-expression, from self-expression to self-confidence and from self-confidence to self-reliance and self-esteem!</li>
                </ul>
            </div>
            <hr />
            <div >
                <h5 style={{ left: "0" }}>Admission Guidelines</h5>
                <p>
                   
                    <li>
            <b>Online Registration: </b> Learner needs to visit <a href="https://www.gjuskillcourses.hkcl.in">www.gjuskillcourses.hkcl.in</a> and make an online payment for admission confirmation. Kindly refer online admission process guidelines for more details.
          </li>
                </p>
            </div>
            <hr />

            <h5>Syllabus</h5>

            <div className='p-4' >

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="7">Networking Basics</AccordionHeader>
                        <AccordionBody accordionId="7">
                            <ul>
                                <li>Basics of Networking</li>
                                <li>OSI Model</li>
                                <li>TCP/IP Model</li>
                                <li>Reference Link 1</li>
                                <li>OSI/TCP Model</li>
                                <li> Network Protocols</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="8">Network Connectivity </AccordionHeader>
                        <AccordionBody accordionId="8">
                            <ul>
                                <li>Network Topology and Network Devices</li>
                                <li>Reference Link</li>
                                <li>Network Cabling</li>
                                <li> Internet Connectivity Types</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="9">IP Addressing</AccordionHeader>
                        <AccordionBody accordionId="9">
                            <ul>
                                <li> Basics of IP addressing</li>
                                <li>Classes of IP addresses</li>
                                <li>Difference Between Static and Dynamic IPs</li>
                                <li>Subnetting</li>
                                <li>Configuring DHCP for Small Network</li>
                                <li>Network Ports</li>
                                <li>Overview of DNS</li>
                                <li>WINS vs DNS</li>
                                <li>MAC Address Formats</li>
                                <li>Troubleshooting of Networks</li>
                                <li>Network Troubleshooting Tools</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="10">Wi-Fi Networks</AccordionHeader>
                        <AccordionBody accordionId="10">
                            <ul>
                                <li>Configuring Wi-Fi Network</li>
                                <li> Wireless Standards</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>


            </div >
            <hr />

            <h5>IT Network Support (HKCL Certificate in IT Network Support)</h5>

            <p><b>Skills:</b>Basics of Networking, Network Cabling, Basics of IP addressing, Configuring DHCP for Small Network, Troubleshooting of Networks, Configuring Wi-Fi Network</p>
            <p><b>Outputs:</b>IT helpdesk, Network monitoring tools, LAN testers, Command line tools, Open source subnet calculators, Network packet analyzers</p>

            <br />
            <hr />



            <div style={{ overflowX: 'auto' }}>
        <h5>Evaluation Pattern</h5>
        <Table bordered striped >
          <thead>
            <tr>
              <th>Section No.</th>
              <th>Section Name</th>
              <th>Total Marks</th>
              <th>Minimum Passing Marks</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Learning Progression</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Internal Assessment</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Final Online Examination</td>
              <td>50</td>
              <td>20</td>
            </tr>
            <tr>
              <th colSpan="2" style={{ textAlign: "right" }}> Total</th>
              <th>100</th>
              <th>40</th>
            </tr>
            
          </tbody>
        </Table>
      </div>
      <hr />

      <div>
        <h5>Certificate of Completion</h5>
        <p>
          The certificate will be provided to the learner who will satisfy the below criteria:
        </p>
        
          <li>
            Learners who have successfully completed above mentioned 3 Sections i.e. Section 1, Section 2, and Section 3.
          </li>
          
        
      </div>
      <hr />
      <div>
        <h5>Fee Structure</h5>
        <p>Fee applicable from 2024 Batch onwards as mentioned below:</p>
        <Table bordered>
          <thead>
            <tr>
              <th>Mode</th>
              <th>Total Fee (Rupees)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Single Installment</td>
              <td>4500/-</td>
            </tr>
          </tbody>
        </Table>
        <p>Total fee is including of Course fees, Examination fees, and Certification fees.</p>
      </div>
     

      <li>
        <span style={{ color: 'red' }}>
         Additionally, the One Time Registration Fee is Rs. 100/-. </span>
      </li>
      


    </div >
    </>
    );
}
export default CertificateInformation6;